import { __decorate, __metadata } from 'tslib';
import { nameOfClass } from '@tencent/workbench-core';
import { Service } from '../decorators/class/service.js';
import { UIService } from '../controllers/base/ui-service.js';
import { SERVICE_NAME_TO_ITEM_NAME } from '../constants/ui-service-item-name.js';

/**
 * UI service集合
 *
 * @public
 */
let ServiceCollection = class ServiceCollection {
    constructor(...services) {
        this.serviceMap = new Map();
        this.serviceOptions = new Map();
        for (const service of services) {
            if (service instanceof UIService) {
                this.serviceMap.set(nameOfClass(service), service);
            }
        }
    }
    getControllerRelatedUIServices() {
        return this.serviceMap;
    }
    has(serviceClass) {
        return this.serviceMap.has(nameOfClass(serviceClass));
    }
    add(service, options) {
        const name = nameOfClass(service);
        this.serviceMap.set(name, service);
        if (options) {
            this.serviceOptions.set(name, options);
        }
    }
    get services() {
        return [...this.serviceMap.values()];
    }
    get(name) {
        return this.serviceMap.get(name);
    }
    getItemName(serviceName) {
        var _a, _b;
        return (_b = (_a = this.serviceOptions.get(serviceName)) === null || _a === void 0 ? void 0 : _a.itemName) !== null && _b !== void 0 ? _b : SERVICE_NAME_TO_ITEM_NAME[serviceName];
    }
};
ServiceCollection = __decorate([
    Service(),
    __metadata("design:paramtypes", [UIService])
], ServiceCollection);

export { ServiceCollection };
//# sourceMappingURL=service-collection.js.map
